import React, { useEffect, useState } from "react";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, CardBody, CardHeader, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import "datatables.net-responsive-dt";
import { useApiStore } from "../../hooks/ApiStoreContext";
import Swal from "sweetalert2";

function Coupon() {
  const apiStore = useApiStore();
  DataTable.use(DT);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getCouponList();
  }, []);

  const getCouponList = async () => {
    try {
      const response = await apiStore.get("/coupon");
      setTableData(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching coupons!", error);
      }
    }
  };

  const handleAdd = (e) => {
    e.preventDefault();
    navigate("/add-coupon");
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    navigate("/add-coupon/" + id);
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await apiStore.delete(`/coupon/${id}`);
        await Swal.fire("Deleted!", "Coupon deleted successfully.", "success");
        getCouponList();
      } catch (error) {
        if (error.response.status !== 401) {
          console.error("There was an error deleting the coupon!", error);
          Swal.fire("Error!", "There was an error deleting the coupon.", "error");
        }
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your coupon is safe :)", "error");
    }
  };

  const handleStatus = async (e, data, row) => {
    try {
      const submitData = {
        couponId: row.couponId,
        code: row.code,
        discountPercent: row.discountPercent,
        expirationDate: row.expirationDate,
        description: row.description,
        isActive: !data,
        isValidForAllUsers: row.isValidForAllUsers,
        couponUsers: row.couponUsers,
        updatedDate: new Date(),
      };
      await apiStore.put(`/coupon/${row.couponId}`, submitData);
      getCouponList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the coupon status!", error);
      }
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Card className="mb-4">
          <CardHeader className="pb-0">
            <Row>
              <Col md={9}>
                <h4>Coupon List</h4>
              </Col>
              <Col md={3} className="d-grid d-md-flex justify-content-md-end d-sm-block">
                <Button variant="outline-primary" className="btn-sm" onClick={handleAdd}>
                  Add Coupon
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="px-0 pt-0 pb-2">
            <div className="mx-3">
              <DataTable
                className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: "code", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "description", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "discountPercent", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "isActive", className: "text-sm font-weight-bold align-middle text-center" },
                    { data: "couponId", className: "text-secondary text-sm font-weight-bold align-middle text-center" },
                  ],
                }}
                slots={{
                  3: (data, row) => {
                    return (
                      <React.Fragment>
                        <span className={data ? "badge badge-sm cursor-pointer bg-gradient-success" : "badge badge-sm cursor-pointer bg-gradient-danger"} onClick={(e) => handleStatus(e, data, row)}>
                          {data ? "Active" : "Inactive"}
                        </span>
                      </React.Fragment>
                    );
                  },
                  4: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className="me-3 cursor-pointer" title="Edit" onClick={(e) => handleEdit(e, data)}>
                          <FontAwesomeIcon icon={faPencil} size="lg"></FontAwesomeIcon>
                        </a>
                        <a className="text-danger cursor-pointer" title="Delete" onClick={(e) => handleDelete(e, data)}>
                          <FontAwesomeIcon icon={faTrashCan} size="lg"></FontAwesomeIcon>
                        </a>
                      </React.Fragment>
                    );
                  },
                }}>
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Code</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Description</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Discount Percent</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Status</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default Coupon;